import { call, put } from "redux-saga/effects";
import {
  setAllPartRequest,
  setNewPartRequests,
  setActivePartRequests,
  setCompletedPartRequests,
  setArchivedPartRequests,
  setPartRequestDetails,
} from "../../entities/partRequest";
import {
  requestGetNewPartRequests,
  requestGetPartRequestsByState,
  requestGetPartRequestDetails,
} from "../requests/partRequest";



export function* handleGetNewPartRequests(action) {
  try {
    const { limit = 100, offset = 0 } = action.payload || {};
    const response = yield call(requestGetNewPartRequests, limit, offset);
    if (!response || !response.data) return;

    const { data } = response;

    yield put(setNewPartRequests({
      rows: data.part_requests,
      count: data.count,
    }));
  } catch (error) {
    console.error("Greška u handleru za nove zahteve:", error);
  }
}


export function* handleGetPartRequestsByState(action) {
  try {
    const { state = [] } = action.payload;
    const response = yield call(
      requestGetPartRequestsByState,
      state,
    );

    const activeStates = [1, 2, 16];
    const archivedStates = [4];
    const isActive = state.some((s) => activeStates.includes(s));
    const isArchived = state.some((s) => archivedStates.includes(s));

    if (state.length === 0) {
      yield put(setAllPartRequest(response.data));
    } else if (isActive) {
      yield put(setActivePartRequests(response.data));
    } else if (isArchived) {
      yield put(setArchivedPartRequests(response.data));
    } else {
      yield put(setCompletedPartRequests(response.data));
    }
  } catch (error) {
    console.error("Greška u handleru za zahteve po stanju:", error);
  }
}




export function* handleGetPartRequestDetails(action) {
  try {
    const { id } = action.payload;
    const response = yield call(requestGetPartRequestDetails, id);
    if (!response || !response.data) return;
    yield put(setPartRequestDetails(response.data));
  } catch (error) {
    console.error("Greška u handleru za detalje zahteva:", error);
  }
}
